import { createAsyncThunk } from "@reduxjs/toolkit"
import { FetchFromBackoffice, PostQueryBackoffice } from "../../utils/request"
import { IPagedResponse } from "../../common-types"
import { PatchToBackoffice, PostToBackoffice } from "../../utils/commands"

export type RecipeItem = {
    transactionId:string,
    serialNumber:string,
    machineName:string,
    startedAt: string,
    endedAt: string | undefined,
    status: string,
    recipeName: string,
    excludedFromInvoicing: boolean,
    excludedFromInvoicingReason: string | undefined,
}

export const fetchRecipesForMachine = createAsyncThunk(
    "FETCH_MACHINE_RECIPES",
    async ({machineId, paging, count}:{machineId: string, paging: number, count: number}) => {
    const response  = await 
        FetchFromBackoffice<IPagedResponse<RecipeItem>>(`machines/${machineId}/recipes?page=${paging}&count=${count}`)

        return response 
    },
  )
  export const setRecipeAsIncludedinInvoicing = createAsyncThunk(
    "SET_RECIPE_AS_INCLUDED",
    async ({machineId, transactionId}:{machineId: string, transactionId: string}) => {
    const response  = await PostToBackoffice('cmd/machine/include/run/invoice', {
        id: machineId,
        transactionId: transactionId,
    })
    return response
    },
  )

  export const postExcludeFromInvoicing = createAsyncThunk(
    "SET_RECIPE_AS_EXCLUDED",
    async ({id, transactionId, reason}:{id: string, transactionId: string,reason: string }) => {
    const response = await  PostToBackoffice('cmd/machine/exclude/run/invoice', {
        id: id,
        transactionId: transactionId,
        reason: reason,
    })
    return response
})


export const setMachineAsActive = createAsyncThunk(
    "SET_MACHINE_TO_ACTIVE",
    async ({serialNumber}:{serialNumber:string}) => {
         const response = await  PostToBackoffice('cmd/machine/monitor/start', {
            id: serialNumber,
        })
        return response
    })

export const deactivateMachine = createAsyncThunk(
    "DEACTIVATE_MACHINE",
    async ({serialNumber }:{serialNumber:string}) => {
         const response = await  PostToBackoffice('cmd/machine/monitor/stop', {
            id: serialNumber,
        })

        return response
    })

export const pushLatestRecipes = createAsyncThunk(
    "PUSH_LATEST_RECIPES",
    async ({serialNumber }:{serialNumber:string}) => {
         const response = await  PatchToBackoffice('machines/push-latest-recipes', {
            serialNumbers: [serialNumber],
        })

        return response
    })

export const pushRecipe = createAsyncThunk(
    "PUSH_RECIPE",
    async ({serialNumber, recipe }:{serialNumber:string, recipe: any}) => {
         const response = await  PostQueryBackoffice('machines/push-recipe', {
            serialNumber: serialNumber,
            recipe: recipe
        })

        return response
    })

export const saveRecipe = createAsyncThunk(
    "SAVE_RECIPE",
    async ({ recipe }:{ recipe: any}) => {
         const response = await  PostToBackoffice('cmd/recipes/v2/instructions', {
            id: recipe.Id,
            name: recipe.Name,
            imagePath: recipe.ImagePath,
            total_execution_time_ms: recipe.total_execution_time_ms,
            fromVersion: '0.7.0',
            instructions: recipe.Instructions,
            isEditable: true
        })

        return response
    })

export const deleteRecipe = createAsyncThunk(
    "DELETE_RECIPE",
    async ({ articleNumber, recipeId, fromVersion }:{ articleNumber: string, recipeId: string, fromVersion: string }) => {
         const response = await  PostToBackoffice('cmd/recipes/delete-instructions', {
            id: articleNumber,
            recipeId: recipeId,
            fromVersion: fromVersion
        })

        return response
    })

export type CalibrationStatus = {
    id: string
    status: string
    createdAt: string
    startedAt: string
    endedAt: string | null
    duration: number
}    

type FetchCalibrationStatusArgs = {
  articleNumber: string
  serialNumber: string
  pushedAt: string
}

export const fetchCalibrationStatus = createAsyncThunk<CalibrationStatus, FetchCalibrationStatusArgs>(
    "FETCH_CALIBRATION_STATUS",
    async ({ articleNumber, serialNumber, pushedAt }:{ articleNumber: string, serialNumber: string, pushedAt: string }) => {
         const response = await FetchFromBackoffice<CalibrationStatus>(`recipes/recipe-lab/calibration-status?ArticleNumber=${articleNumber}&SerialNumber=${serialNumber}&PushedAt=${pushedAt}`)
        return response
    })